// package
import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    Button,
    Card,
    Col,
    Row,
    Form,
    Spinner,
} from "react-bootstrap";
import MaskedInput from "react-text-mask-legacy";
import AmlHashForm from "aml-hash-form";

// component
import { common, config } from "includes";

export default function AccountDeletionForm() {
    // state
    const [submit, setSubmit] = useState<any>("");

    // form
    const formFieldsA = {
        firstName: { validate: ["req#First Name is required"] },
        lastName: { validate: ["req#Last Name is required"] },
        email: {
            validate: [
                "req#Email is required",
                "regExp#Please Enter valid email address",
                "custom#Email already exists"
            ],
            pattern: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        },
        mobile: { validate: [] },
        reason: { validate: ["req#Reason is required"] },
    };

    const {
        fields: fieldsA,
        errors: errorsA,
        handleChange: handleChangeA,
        handleSubmit: handleSubmitA,
        setValue: setValueA,
        setMultiValue: setMultiValueA,
    } = AmlHashForm(formFieldsA);

    useEffect(() => {
        console.log("===============fieldsA", fieldsA);

    }, [])

    const deleteUser = async () => {
        let data = common.formPayload(fieldsA, ["mobile"]);
        data.mobile = fieldsA.mobile ? fieldsA.mobile.replace(/[\(\)\-\s]/g, "") : "";
        fetch(config.api.url + "admin/user", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
        })
            .then((response) =>
                response.text().then((data) => ({
                    status: response.status,
                    data: data,
                }))
            )
            .then((result: any) => {
                if (result.status === 200) {
                    common.notify("S", "User deleted request submitted successfully");
                    setSubmit("");
                    setMultiValueA({
                        firstName: "",
                        lastName: "",
                        email: "",
                        mobile: "",
                        reason: "",
                    });
                } else {
                    common.notify("E", "Something went wrong!");
                    setSubmit("");
                }
            })
            .catch((err) => {
                common.notify("E", err.toString());
                setSubmit("");
            });
    };

    // events
    const onSubmit = (e: any) => {
        e.preventDefault();
        const isValid = handleSubmitA();
        setSubmit("submit");
        if (isValid) {
            setSubmit("proceed");
            deleteUser();
        }
    };

    return (
        <Fragment>
            <Row className="justify-content-center">
                <Col xxl={4} lg={5}>
                    <Card>
                        <Card.Header className="py-4 text-center bg-primary">
                            <Link to="/">
                                <span>
                                    <img src={common.loadImg("logo.png")} alt="logo" height="30" />
                                </span>
                            </Link>
                        </Card.Header>
                        <Card.Body className="p-4">
                            <div className="text-center w-75 m-auto">
                                <h4 className={`text-dark-50 text-center pb-0 fw-bold`}>
                                    DELETE AN ACCOUNT
                                </h4>
                                <p className="text-muted mb-4">
                                    We're sorry to see you go! Complete the form below to delete your account.
                                </p>
                            </div>
                            <Row>
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <Form>
                                                <Row>
                                                    <Col md={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>First Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                id="singleLine"
                                                                maxLength={100}
                                                                data-toggle="maxlength"
                                                                placeholder="Enter first name"
                                                                name="firstName"
                                                                value={fieldsA.firstName}
                                                                onChange={handleChangeA}
                                                                isInvalid={errorsA.firstName && submit === "submit" ? true : false}
                                                            />
                                                            {errorsA.firstName && submit === "submit" &&
                                                                <Form.Control.Feedback type="invalid">
                                                                    {errorsA.firstName}
                                                                </Form.Control.Feedback>
                                                            }
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Last Name</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="lastName"
                                                                id="singleLine"
                                                                maxLength={100}
                                                                data-toggle="maxlength"
                                                                placeholder="Enter last name"
                                                                value={fieldsA.lastName}
                                                                onChange={handleChangeA}
                                                                isInvalid={errorsA.lastName && submit === "submit" ? true : false}
                                                            />
                                                            {
                                                                errorsA.lastName && submit === "submit" &&

                                                                <Form.Control.Feedback type="invalid">
                                                                    {errorsA.lastName}
                                                                </Form.Control.Feedback>
                                                            }
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Email</Form.Label>
                                                            <Form.Control
                                                                type="email"
                                                                name="email"
                                                                id="singleLine"
                                                                placeholder="Enter Email"
                                                                value={fieldsA.email}
                                                                onChange={handleChangeA}
                                                                autoComplete="new-email"
                                                                isInvalid={errorsA.email && submit === "submit" ? true : false}
                                                            />
                                                            {
                                                                errorsA.email && submit === "submit" &&
                                                                <Form.Control.Feedback type="invalid">
                                                                    {errorsA.email}
                                                                </Form.Control.Feedback>
                                                            }
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Mobile</Form.Label>
                                                            <MaskedInput
                                                                mask={[
                                                                    "(",
                                                                    /[1-9]/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    ")",
                                                                    " ",
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    "-",
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                    /\d/,
                                                                ]}
                                                                placeholder="Enter Mobile"
                                                                className="form-control"
                                                                value={fieldsA.mobile}
                                                                onChange={(e) =>
                                                                    setValueA("mobile", e.target.value)
                                                                }
                                                            />
                                                            {/* {errorsA.mobile && submit === "submit" && (
                                                                <span className="text-danger fs-6">
                                                                    {errorsA.mobile}
                                                                </span>
                                                            )} */}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Reason</Form.Label>
                                                            <Form.Control
                                                                as="textarea"
                                                                name="reason"
                                                                rows={6}
                                                                placeholder="Why are you choosing to delete your account?"
                                                                value={fieldsA.reason}
                                                                onChange={handleChangeA}
                                                                isInvalid={errorsA.reason && submit === "submit" ? true : false}
                                                            />
                                                            {
                                                                errorsA.reason && submit === "submit" &&
                                                                <Form.Control.Feedback type="invalid">
                                                                    {errorsA.reason}
                                                                </Form.Control.Feedback>
                                                            }
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <div className="mb-3 text-center">
                                                    <Button
                                                        variant="primary"
                                                        onClick={(e) => onSubmit(e)}
                                                        // disabled={submit === "proceed"}
                                                    >
                                                        {submit === "proceed" ? (
                                                            <>
                                                                <Spinner
                                                                    className="spinner-border-sm me-1"
                                                                    color="white"
                                                                />
                                                                Processing...
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="ri-save-line" /> Submit
                                                            </>
                                                        )}
                                                    </Button>
                                                </div>
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    );
}
